import { render, staticRenderFns } from "./UserMessageHistory.vue?vue&type=template&id=08a2dcde&lang=html"
import script from "./UserMessageHistory.vue?vue&type=script&lang=js"
export * from "./UserMessageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports